export const dynamicBlockType = {
  CONTENT_BLOCK: 'CONTENT_BLOCK',
  TEXT_BLOCK: 'TEXT_BLOCK',
  IMAGE_BLOCK: 'IMAGE_BLOCK',
  BROWSER_BLOCK: 'BROWSER_BLOCK',
  SCROLL_BROWSER_BLOCK: 'SCROLL_BROWSER_BLOCK',
  PRODUCT_BLOCK: 'PRODUCT_BLOCK',
  PRODUCT_SHOP_BLOCK: 'PRODUCT_SHOP_BLOCK',
  BUTTON_BLOCK: 'BUTTON_BLOCK',
  CART_BLOCK: 'CART_BLOCK',
  INITIAL_RECOMMENDATION_BLOCK: 'INITIAL_RECOMMENDATION_BLOCK',
  LANGUAGE_BLOCK: 'LANGUAGE_BLOCK',
  LANGUAGE_SELECT_BLOCK: 'LANGUAGE_SELECT_BLOCK',
  SCROLL_TEXT_BLOCK: 'SCROLL_TEXT_BLOCK'
};
